import React from "react";
import DialogActions from "@material-ui/core/DialogActions";
import { SaveButton } from "../ActionButtons";

const ChatiaDialogActions = ({ onSave, onClick, loading, disabled, saveText, type, children, className }) => {
    return (
        <DialogActions className={className}>
            {children}
            <SaveButton
                onClick={onSave || onClick}
                type={type || "submit"}
                disabled={disabled}
                loading={loading}
            >
                {saveText || "Salvar"}
            </SaveButton>
        </DialogActions>
    );
};

export default ChatiaDialogActions;
